<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Vinculo de Função' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <ion-grid class="gradient-container">
    <div class="gradient-overlay"></div>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <img [src]="pessoa.foto | image:' '" class="image" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <p class="nome-pessoa bold-2">
          {{pessoa.id ? pessoa.nome : ("Nenhuma Pessoa Selecionada" |
          translate)}}
        </p>

        <p class="funcao">{{funcao.nome}}</p>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="10">
        <div>
          <ion-button
            class="btn-default"
            expand="block"
            (click)="selecionarPessoa();"
          >
            {{ pessoa.id ? ("Alterar Pessoa" | translate) : ("Selecionar Pessoa"
            | translate)}}
          </ion-button>
        </div>
      </ion-col>
    </ion-row>

    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <div>
        <ion-item-divider></ion-item-divider>

        <ion-card-header>
          {{'Configurações' | translate}}
        </ion-card-header>

        <ion-card-content class="remove-border">
          <ion-list>
            <ion-item class="switcher-item">
              <ion-toggle
                justify="space-between"
                formControlName="mostrarReuniao"
                [enableOnOffLabels]="true"
                class="config bold-1"
                >{{'Incluir na Lista de Presença ?' | translate}}</ion-toggle
              >
            </ion-item>

            <ion-item class="switcher-item">
              <ion-toggle
                justify="space-between"
                formControlName="exibirAppPortal"
                [enableOnOffLabels]="true"
                class="config bold-1"
                >{{'Exibir no Aplicativo ?' | translate}}</ion-toggle
              >
            </ion-item>
          </ion-list>

          <div class="down">
            <ion-button
              class="btn-success"
              expand="block"
              type="submit"
              [disabled]="!validations_form.valid || !pessoa.id"
              >{{'Salvar' | translate}}
            </ion-button>
          </div>
        </ion-card-content>
      </div>
    </form>
  </ion-grid>
</ion-content>
